import { render } from "./SmsOTP.vue?vue&type=template&id=487778aa"
import script from "./SmsOTP.vue?vue&type=script&lang=js"
export * from "./SmsOTP.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__